(() => {
  const readStorage = (key) => {
    try { return window.localStorage.getItem(key); } catch (_error) { return null; }
  };

  const writeStorage = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch (_error) { /* Storage can be disabled. */ }
  };

  const init = (root) => {
    if (!root || root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    const dialog = root.querySelector("[data-offer-dialog]");
    const opener = root.querySelector("[data-offer-open]");
    const closer = root.querySelector("[data-offer-close]");
    if (!dialog || typeof dialog.showModal !== "function") return;

    const key = root.dataset.storageKey || "evemx-offer";
    const delay = Number.parseInt(root.dataset.delay || "6000", 10);
    const filled = readStorage("evemx-offer-filled") === "true";

    const open = () => {
      if (!dialog.open) dialog.showModal();
      root.classList.add("is-open");
      writeStorage(key, "true");
    };
    const close = () => {
      if (dialog.open) dialog.close();
    };

    opener?.addEventListener("click", open);
    closer?.addEventListener("click", close);
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener("close", () => {
      root.classList.remove("is-open");
      if (!filled) root.classList.add("is-tab-visible");
    });

    if (!filled) {
      window.setTimeout(() => root.classList.add("is-tab-visible"), Math.max(0, delay));
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll("[data-evemx-offer]").forEach(init);
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => initAll()) : initAll();
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
